﻿onLoad();

document.addEventListener('DOMContentUpdated', e => onLoad(e.target));

export function onLoad(context = document) {
    // When a form failure occurs we need to reset it.
    context.querySelectorAll('form').forEach(form => {
        form.addEventListener('failure', () => {
            form.querySelectorAll('.captcha').forEach(captcha => captcha.src = '/captcha-image?v=' + Date.now());
        });
    });
}